import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';



import { ApplicationConfigService } from './app-config-service';
import { SearchWithPagination } from '../models/request.model';
import { Product } from '../models/product.model';

export type EntityResponseType = HttpResponse<Product>;
export type EntityArrayResponseType = HttpResponse<Product[]>;

@Injectable({ providedIn: 'root' })
export class namChatService {
  
  
  protected resourceSearchUrl = this.applicationConfigService.getJpaMicroServiceEndpointFor('api/productsForPublic');
  protected offerUrl = this.applicationConfigService.getMongoMicroServiceEndpointFor('api/public/triggerOfferPublic');

  //
  
  constructor(protected http: HttpClient, protected applicationConfigService: ApplicationConfigService) {}


  search(req: any): Observable<EntityArrayResponseType> {
    const options = this.createRequestOption(req);
    return this.http.get<Product[]>(this.resourceSearchUrl, { params: options, observe: 'response' });
  }

  enquire(req: any) : Observable<HttpResponse<string>>{
    return this.http.post<string>(this.offerUrl, req, {observe: 'response'});
  }

  private createRequestOption = (req?: any): HttpParams => {
    let options: HttpParams = new HttpParams();
  
    if (req) {
      Object.keys(req).forEach(key => {
        if (key !== 'sort' && key !== 'custom') {
          options = options.set(key, req[key]);
        }
      });
  
      if (req.sort) {
        req.sort.forEach((val: string) => {
          options = options.append('sort', val);
        });
      }
  
      if (req.custom) {
        req.custom.forEach((val: any) => {
          options = options.append(val.label, val.field);
        });
      }
    }
  
    return options;
  };
  

 
}
